import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { _HealthEntity, _ImportHealthEntity } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { FileInput } from "../../../../theme/Component/FileInput";
import { InputDate } from "../../../../theme/Input/InputDate";


export const HealthEntity = () => {

    const health = useDataBean(_HealthEntity);
    const imphealt = useDataBean(_ImportHealthEntity);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modalImp, setModalImp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        health.instance.getHealthEntityCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                   
                }
            }
        )

    }
    const create = () => {
        health.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        health.instance.deleteVoid(health.bean.IDHealthEntity).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        health.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const importHealthEntityCatalog = () => {
        //console.log(entailment.bean);
        imphealt.instance.importHealthEntityCatalog(imphealt.bean.Media, imphealt.bean.MediaContext, null).then(
            (resp: any) => {
                // getLista();
                setModalImp({ ...modalImp, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const verimp = () => {

      setModalImp({ ...modalImp, "view": true });

    }
    const head = [
        { title: 'ID', property: 'IDHealthEntity', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Nit', property: 'Nit', visible: true },
        { title: 'Tipo', property: 'HealthEntityTypeName', visible: true },
        { title: 'Grupo', property: 'HealthEntityGroupName', visible: true },
        { title: 'Código Habilitación', property: 'EnablingCode', visible: true },
        { title: 'Fecha Habilitación', property: 'InitDate', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Entidades Prestadoras de Servicios de Salud">
            <div className="row">
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-2 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                 <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={verimp}>Importar Entidades de Prestación de Servicios Médicos</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={health.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={health.bean.Name} onChange={health.handleChange} />
                            </div>
                             <div className="col-md-6">
                                <AccountEditor label="Tercero" idAccount={health.bean.IDAccount} onChange={(e) => { health.setBean({ ...health.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                             <div className="col-md-6">
                                <label>NIT</label>
                                <input type="text" name="Nit" className="form-control" value={health.bean.Nit} onChange={health.handleChange} />
                            </div>
                              <div className="col-md-6">
                                <label>Tipo</label>
                                <input type="text" name="HealthEntityTypeName" className="form-control" value={health.bean.HealthEntityTypeName} onChange={health.handleChange} />
                            </div>
                              <div className="col-md-6">
                                <label>Grupo</label> 
                                <input type="text" name="HealthEntityGroupName" className="form-control" value={health.bean.HealthEntityGroupName} onChange={health.handleChange} />
                            </div>
                                 <div className="col-md-6">
                                 <label>Código Habilitación</label>
                                <input type="text" name="EnablingCode" className="form-control" value={health.bean.EnablingCode} onChange={health.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="" value={health.bean.InitDate} label="Fecha Habilitación" setDate={(e) => health.setBean({ ...health.bean, 'InitDate': e })} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={health.bean.Description} onChange={health.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalImp} updateModal={setModalImp} eventModal={importHealthEntityCatalog}>
                        <div className="row">
                        <div className="col-md-12">
                            <FileInput
                                Media={imphealt.bean.Media}
                                MediaContext={imphealt.bean.MediaContext}
                                directory='transporte'
                                label='Archivo'
                                onCreate={(Filemap: any) => { imphealt.setBean({ ...imphealt.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                            ></FileInput>
                          </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {health.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}